/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { Typography, Box, Card, CardContent } from '@mui/material';
import { styled } from '@mui/system';
import { Container } from '@mui/material';
import ItemList from './ItemList';
import StoreIcon from '@mui/icons-material/Store';
import {Helmet} from "react-helmet";

const StyledTypography = styled(Typography)({
    textAlign: 'center',
    fontSize: '1.2rem',
    fontWeight: '600',
    marginTop: '1rem',
});

const StyledTypographyBio = styled(Typography)({
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: '400',
    marginTop: '0.5rem',
    marginBottom: '1rem',
});

const StyledCard = styled(Card)({
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
    borderRadius: '15px',
    padding: '2rem',
    marginTop: '0rem',
    backgroundColor: '#f2f2f2',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginBottom: '2rem'
});

const Shop = () => {
    const { user, isAuthenticated } = useAuth0();
    const [petOwnerProfile, setPetOwnerProfile] = useState({
        name: '',
        bio: '',
        fileUrl: '',
    });

    useEffect(() => {
        const fetchPetOwnerProfile = async () => {
            if (isAuthenticated && user) {
                try {
                    const response = await fetch('/.netlify/functions/getPetOwnerProfile', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userEmail: user.email }),
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error ${response.status}`);
                    }

                    const petOwnerProfileData = await response.json();

                    setPetOwnerProfile(petOwnerProfileData);
                } catch (error) {
                    console.error('Error fetching pet owner profile:', error);
                }
            }
        };

        fetchPetOwnerProfile();
    }, [user, isAuthenticated]);

    return (
        <Container maxWidth="md">
            <Helmet>
                <title>Wagzters - Shopping</title>
                <meta name="description" content="Wagzters - Explore a wide variety of pet supplies provided by our affiliate partners on Wagzters. From food, toys, to accessories, find everything your pet needs in one place."/>
                <meta property="og:title" content="Wagzters - Shopping" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://i.imgur.com/jrbqoWp.png" />
                <meta property="og:url" content="https://wagzters.com/shop" />
                <meta property="og:description" content="Wagzters - Explore a wide variety of pet supplies provided by our affiliate partners on Wagzters. From food, toys, to accessories, find everything your pet needs in one place." />
            </Helmet>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    mt: 0
                }}>
                {isAuthenticated && user && (
                    <StyledCard>
                        <StoreIcon
                            sx={{
                                fontSize: 80,
                                marginTop: '1rem',
                                color:'#FE9740'
                        }}
                        />
                        <CardContent>
                            <StyledTypography variant="h5" sx={{
                                color:'#333333'
                            }}>
                                {'Shopping' || ''}
                            </StyledTypography>
                            <StyledTypographyBio variant="body2" color="#9ca3af">
                                {'Browse Pawesome Deals'}
                            </StyledTypographyBio>
                        </CardContent>
                    </StyledCard>
                )}
                <ItemList />
            </Box>
        </Container>
    );
};

export default Shop;
